import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/reviews`;

// All Reviews tab — paginated, filterable by rating / restaurant / search.
export const getReviews = (params = {}) => axios.get(BASE, { params });

// By Order tab — filter the same list by (partial) order number.
export const getReviewsByOrderNumber = (orderNumber, params = {}) =>
  axios.get(BASE, { params: { ...params, orderNumber } });

// Single order's review(s), by order id — used for a direct order lookup.
export const getReviewsForOrder = (orderId) => axios.get(`${BASE}/by-order/${orderId}`);

// Super Admin edit: { rating?: 1-5, comment?: string, status?: 'ACTIVE' | 'INACTIVE' }
export const updateReview = (id, data) => axios.patch(`${BASE}/${id}`, data);
